import React, { Component } from "react";
import {
  loading,
  NavbarWarehouse,
  Pagination,
  Modal,
  t,
  Select,
  ActionIconButton,
  ACTION_ICONS
} from "../../components/CustomComponent.js"; // ปรับ Path ให้ตรงกับโปรเจกต์ของคุณ

export default class PartsReturn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // -----------------------------------
      // Filter States
      // -----------------------------------
      filter_search: "",
      filter_type: "",
      filter_status: "",

      count: 156,
      page: 1,
      page_size: 10,

      // -----------------------------------
      // Modal States
      // -----------------------------------
      modal_create: false,

      // Form States (for Modal "รับคืนอะไหล่ใหม่")
      form_return_from: "VAN-001 (Somchai)",
      form_return_type: "ไม่ได้ใช้",
      form_ref_doc: "",
      form_return_date: "",
      form_note: "",
      
      // Items in Modal
      form_return_items: [
        { id: "PRT-002456", desc: "Filter Element", qty: 2, condition: "ดี", note: "" }
      ],

      // -----------------------------------
      // Mock Data: Summary Stats
      // -----------------------------------
      summary: {
        waiting_receive: 8,
        waiting_inspect: 3,
        received_this_month: 156,
        damaged: 12,
      },

      // -----------------------------------
      // Mock Data: Returns Table List
      // -----------------------------------
      data: [
        {
          id: "RTN-2025-0089",
          from: "VAN-001 (Somchai)",
          ref_doc: "WO-20250110-0012",
          items_count: 3,
          type: "ไม่ได้ใช้", typeColor: "success",
          time_ago: "1 ชั่วโมงที่แล้ว",
          status: "รอตรวจสอบ", statusColor: "warning",
          can_inspect: true, can_approve: true
        },
        {
          id: "RTN-2025-0088",
          from: "VAN-002 (Prasit)",
          ref_doc: "WO-20250110-0008",
          items_count: 1,
          type: "ชำรุด", typeColor: "danger",
          time_ago: "2 ชั่วโมงที่แล้ว",
          status: "รอตรวจสอบ", statusColor: "warning",
          can_inspect: true, can_approve: true
        },
        {
          id: "RTN-2025-0087",
          from: "VAN-003 (Wichai)",
          ref_doc: "WO-20250109-0015",
          items_count: 5,
          type: "ไม่ได้ใช้", typeColor: "success",
          time_ago: "เมื่อวาน",
          status: "เสร็จสิ้น", statusColor: "success",
          can_view: true, can_print: true
        }
      ]
    };
  }

  async componentDidMount() {
    loading(false);
  }

  Get = async (page) => {
    // API logic will go here
  }

  formatNumber = (num) => {
    return num?.toLocaleString('en-US') || "0";
  };
render() {
    const { 
      data, count, summary, 
      filter_search, filter_type, filter_status,
      modal_create, form_return_from, form_return_type, form_ref_doc, form_return_date, form_note, form_return_items
    } = this.state;

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarWarehouse />
        <div className="body p-4 mt-3">
          
          {/* Header Section */}
            <div className="mb-4">
              <h3 className="fw-bold mb-1 text-dark">{t("return_parts")}</h3>
              <div className="text-secondary text-14">{t("return_parts_subtitle")}</div>
            </div>

          {/* Top Stats Cards (4 Columns) */}
          <div className="row g-3 mb-4">
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded-3 bg-primary-light text-primary d-flex align-items-center justify-content-center text-20 icon">
                    {"\uf0e2"}
                  </div>
                  <div>
                    <h3 className="fw-bold text-dark mb-0">{this.formatNumber(summary.waiting_receive)}</h3>
                    <div className="text-secondary text-12 fw-bold">{t("waiting_return")}</div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded-3 bg-warning-light text-warning d-flex align-items-center justify-content-center text-20 icon">
                    {"\uf002"}
                  </div>
                  <div>
                    <h3 className="fw-bold text-dark mb-0">{this.formatNumber(summary.waiting_inspect)}</h3>
                    <div className="text-secondary text-12 fw-bold">{t("waiting_inspect")}</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded-3 bg-success-light text-success d-flex align-items-center justify-content-center text-20 icon">
                    {"\uf058"}
                  </div>
                  <div>
                    <h3 className="fw-bold text-dark mb-0">{this.formatNumber(summary.received_this_month)}</h3>
                    <div className="text-secondary text-12 fw-bold">{t("received_month")}</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded-3 bg-danger-light text-danger d-flex align-items-center justify-content-center text-20 icon">
                    {"\uf00d"}
                  </div>
                  <div>
                    <h3 className="fw-bold text-danger mb-0">{this.formatNumber(summary.damaged)}</h3>
                    <div className="text-secondary text-12 fw-bold">{t("damaged_total")}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
            {/* Top Filter Toolbar */}
            <div className="border-bottom border-light d-flex flex-wrap justify-content-between align-items-center gap-3">
              <div className="d-flex gap-3 flex-wrap flex-grow-1">
                <div className="position-relative" style={{ maxWidth: "300px", width: "100%" }}>
                  <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">
                    {"\uf002"}
                  </span>
                  <input
                    type="text"
                    className="form-control ps-5 wpx-300"
                    placeholder={t("search_placeholder")}
                    value={filter_search}
                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                  />
                </div>
                <Select
                  className="form-control wpx-150"
                  options={[
                    { value: "unused", label: t("unused") },
                    { value: "damaged", label: t("damaged") },
                  ]}
                  value={filter_type}
                  onChange={(e) => this.setState({ filter_type: e })}
                  placeholder={t("all_types")}
                  defaultLabel={t("all_types")}
                />
                <Select
                  className="form-control wpx-150"
                  options={[
                    { value: "waiting", label: t("waiting") },
                    { value: "completed", label: t("completed") },
                  ]}
                  value={filter_status}
                  onChange={(e) => this.setState({ filter_status: e })}
                  placeholder={t("all_status")}
                  defaultLabel={t("all_status")}
                />
              </div>
              <div className="d-flex gap-2">
                <button 
                  className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center" 
                  style={{ backgroundColor: '#2563eb', borderColor: '#2563eb' }}
                  onClick={() => this.setState({ modal_create: true })}
                >
                  <span className="me-2 text-16">+</span> {t("new_return")}
                </button>
              </div>
            </div>
          </div>

          {/* Main White Container */}
          <div className="bg-white rounded-4 shadow-sm pb-2">
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0" style={{ minWidth: "1000px" }}>
                <thead>
                  <tr className="text-secondary fw-bold text-12 border-bottom border-light">
                    <th className="py-3 px-4 border-0 wpx-200">{t("return_no")}</th>
                    <th className="py-3 border-0 wpx-250">{t("from")}</th>
                    <th className="py-3 border-0 text-center wpx-200">{t("reference")}</th>
                    <th className="py-3 border-0 text-center wpx-100">{t("items")}</th>
                    <th className="py-3 border-0 text-center wpx-120">{t("type")}</th>
                    <th className="py-3 border-0 text-center wpx-150">{t("requested_at")}</th>
                    <th className="py-3 border-0 text-center wpx-120">{t("status")}</th>
                    <th className="py-3 border-0 text-center wpx-100">{t("manage")}</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, idx) => (
                    <tr key={idx} className="border-bottom border-light bg-white">
                      <td className="py-3 px-4">
                        <span className="fw-bold text-primary text-14 pointer hover-underline">{item.id}</span>
                      </td>
                      <td><div className="text-dark text-14">{item.from}</div></td>
                      <td className="text-center"><div className="text-secondary text-14">{item.ref_doc}</div></td>
                      <td className="text-center"><span className="fw-bold text-dark text-14">{item.items_count}</span></td>
                      <td className="text-center">
                        <span className={`badge bg-${item.typeColor}-light text-${item.typeColor} rounded-2 px-2 py-1 fw-bold text-10 border`}>
                          {item.type}
                        </span>
                      </td>
                      <td className="text-center"><div className="text-dark text-14">{item.time_ago}</div></td>
                      <td className="text-center">
                        <span className={`badge bg-${item.statusColor}-light text-${item.statusColor} rounded-pill px-3 py-1 fw-bold text-10 border border-${item.statusColor}`}>
                          {item.status}
                        </span>
                      </td>
                      <td className="text-center">
                        <div className="d-flex align-items-center gap-2 justify-content-center">
                          {(item.can_view || item.can_inspect) && <ActionIconButton label={t("view")} icon={ACTION_ICONS.view} variant="primary" />}
                          {item.can_approve && <ActionIconButton label={t("approve")} icon={"\uf058"} variant="success" />}
                          {item.can_print && <ActionIconButton label={t("print")} icon={"\uf02f"} variant="primary" />}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

            {/* Footer Pagination */}
            <div className="d-flex justify-content-between align-items-center p-4 border-top border-light flex-wrap text-secondary text-12">
              <div>{t("showing")} 1-{data.length} {t("of")} {this.formatNumber(count)} {t("records")}</div>
              <Pagination
                className="mb-0"
                count={Math.ceil(count / 10) || 1}
                showFirstButton={false}
                showLastButton={false}
                onChange={(_, page) => this.Get(page)}
              />
            </div>
        </div>

        {/* MODAL: New Parts Return */}
        <Modal
          size="lg"
          show={modal_create}
          onHide={() => this.setState({ modal_create: false })}
          centered
          contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
        >
          <Modal.Header className="bg-white border-bottom border-light px-4 py-3" closeButton>
            <h4 className="fw-bold mb-0 text-dark">{t("add_new_return")}</h4>
          </Modal.Header>
          <Modal.Body className="p-4 bg-white" >
            
            <div className="row g-4 mb-4">
              <div className="col-md-6">
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("return_from_label")} <span className="text-danger">{t("required_field")}</span></label>
                <Select
                  className="form-control py-2"
                  options={[
                    { value: "VAN-001 (Somchai)", label: "VAN-001 (Somchai)" },
                    { value: "VAN-002 (Prasit)", label: "VAN-002 (Prasit)" },
                  ]}
                  value={form_return_from}
                  onChange={(e) => this.setState({ form_return_from: e })}
                  placeholder="VAN-001 (Somchai)"
                  default={false}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("return_type_label")} <span className="text-danger">{t("required_field")}</span></label>
                <Select
                  className="form-control py-2"
                  options={[
                    { value: "unused", label: t("unused") },
                    { value: "damaged", label: t("damaged") },
                  ]}
                  value={form_return_type}
                  onChange={(e) => this.setState({ form_return_type: e })}
                  placeholder={t("return_type_label")}
                  default={false}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("ref_job_label")}</label>
                <input 
                  type="text" 
                  className="form-control py-2" 
                  placeholder={t("ref_job_label")}
                  value={form_ref_doc}
                  onChange={(e) => this.setState({ form_ref_doc: e.target.value })}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("return_date_label")}</label>
                <div className="position-relative">
                  <input 
                    type="text" 
                    className="form-control py-2" 
                    placeholder="dd/mm/yyyy"
                    value={form_return_date}
                    onChange={(e) => this.setState({ form_return_date: e.target.value })}
                  />
                  <span className="icon position-absolute top-50 end-0 translate-middle-y me-3 text-secondary">{"\uf073"}</span>
                </div>
              </div>
            </div>

            {/* Items List */}
            <div className="mb-4">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="fw-bold text-dark mb-0">{t("return_items_list")}</h6>
                <button className="btn btn-sm text-primary fw-bold d-flex align-items-center px-0">
                  <span className="me-1">+</span> {t("add_item")}
                </button>
              </div>
              
              <div className="table-responsive bg-light p-2 rounded-3 border border-light">
                <table className="table align-middle mb-0 border-0">
                  <thead>
                    <tr className="text-dark fw-bold text-12">
                      <th className="py-2 border-0 bg-transparent wpx-150">{t("part_code")}</th>
                      <th className="py-2 border-0 bg-transparent wpx-150">{t("description")}</th>
                      <th className="py-2 border-0 bg-transparent text-center wpx-100">{t("quantity")}</th>
                      <th className="py-2 border-0 bg-transparent text-center wpx-100">{t("condition")}</th>
                      <th className="py-2 border-0 bg-transparent wpx-150">{t("reason")}</th>
                      <th className="py-2 border-0 bg-transparent text-center wpx-40"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {form_return_items.map((item, idx) => (
                      <tr key={idx} className="bg-transparent border-bottom border-white">
                        <td className="py-2 px-1">
                          <Select
                            className="form-control form-control-sm rounded-2 text-dark bg-white border-light shadow-none"
                            options={[{ value: item.id, label: item.id }]}
                            value={item.id}
                            onChange={() => {}}
                            placeholder={t("part_code")}
                            default={false}
                          />
                        </td>
                        <td className="py-2 text-secondary text-14 px-1">{item.desc}</td>
                        <td className="py-2 px-1">
                          <input type="number" className="form-control form-control-sm text-center rounded-2 text-dark bg-white border-light shadow-none" value={item.qty} readOnly />
                        </td>
                        <td className="py-2 px-1">
                          <Select
                            className="form-control form-control-sm rounded-2 text-dark bg-white border-light shadow-none"
                            options={[
                              { value: "good", label: t("good_condition") },
                              { value: "damaged", label: t("damaged_condition") },
                            ]}
                            value="good"
                            onChange={() => {}}
                            placeholder={t("good_condition")}
                            default={false}
                          />
                        </td>
                        <td className="py-2 px-1">
                          <input type="text" className="form-control form-control-sm rounded-2 text-secondary bg-white border-light shadow-none" placeholder={t("reason")} value={item.note} readOnly />
                        </td>
                        <td className="py-2 text-center px-1">
                          <span className="icon text-danger pointer text-14">{"\uf2ed"}</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div>
              <label className="form-label text-14 text-dark fw-bold mb-2">{t("note_label")}</label>
              <textarea 
                className="form-control py-2 rounded-3 border-light" 
                rows="3" 
                placeholder={t("note_label")}
                value={form_note}
                onChange={(e) => this.setState({ form_note: e.target.value })}
              ></textarea>
            </div>

          </Modal.Body>
          <Modal.Footer className="bg-white border-top border-light pt-3 px-4 pb-4 d-flex justify-content-end gap-2">
            <button 
              className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold bg-white" 
              onClick={() => this.setState({ modal_create: false })}
            >
              {t("cancel")}
            </button>
            <button className="btn btn-primary px-4 py-2 rounded-3 fw-bold text-white shadow-sm" style={{ backgroundColor: '#2563eb', borderColor: '#2563eb' }}>
              {t("submit_return")}
            </button>
          </Modal.Footer>
        </Modal>

      </div>
    );
  }
}